/* CellCare — carrousel, barre d'achat fixe, variantes, guide de choix. Sans dépendance. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Galerie : défilement par ancrage, compteur, vignettes, flèches. */
  document.querySelectorAll('[data-cc-gallery]').forEach((gal) => {
    const track = gal.querySelector('.cc-gallery__track');
    const slides = [...gal.querySelectorAll('.cc-gallery__slide')];
    const current = gal.querySelector('[data-current]');
    const thumbs = [...gal.querySelectorAll('[data-go]')];
    if (!track || slides.length < 2) return;
    const go = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    };
    const active = () => Math.round(track.scrollLeft / track.clientWidth);
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = active();
        if (current) current.textContent = i + 1;
        thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      });
    }, { passive: true });
    gal.querySelector('[data-prev]')?.addEventListener('click', () => go(active() - 1));
    gal.querySelector('[data-next]')?.addEventListener('click', () => go(active() + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.go))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(active() - 1); }
    });
  });

  /* Barre d'achat fixe (mobile) : visible quand le bouton principal sort de l'écran. */
  const bar = document.querySelector('[data-cc-stickybar]');
  const add = document.querySelector('[data-cc-add]');
  if (bar && add && 'IntersectionObserver' in window) {
    bar.hidden = false;
    const io = new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('cc-has-stickybar', past);
    });
    io.observe(add);
  }

  /* Variantes en pastilles (si le produit en a plusieurs). */
  document.querySelectorAll('[data-cc-variants-picker]').forEach((picker) => {
    const data = JSON.parse(picker.querySelector('[data-cc-variants-json]')?.textContent || '[]');
    const section = picker.closest('.cc-product');
    const idInput = section?.querySelector('[data-cc-variant-id]');
    const money = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    picker.addEventListener('change', () => {
      const values = [...picker.querySelectorAll('[data-cc-option]:checked')].map((i) => i.value);
      picker.querySelectorAll('[data-cc-option-label]').forEach((l, i) => { l.textContent = values[i] || ''; });
      const v = data.find((x) => x.options.every((o, i) => o === values[i]));
      if (!v || !idInput) return;
      idInput.value = v.id;
      section.querySelectorAll('[data-cc-price]').forEach((p) => { p.textContent = money(v.price); });
      section.querySelectorAll('button[type="submit"]').forEach((b) => { b.disabled = !v.available; });
      const stock = section.querySelector('[data-cc-stock]');
      if (stock) {
        stock.classList.toggle('cc-stock--out', !v.available);
        stock.innerHTML = v.available ? '<span class="cc-dot" aria-hidden="true"></span>Disponible' : 'Indisponible';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* Guide de choix en 3 questions. */
  if (!customElements.get('cc-guide')) {
    customElements.define('cc-guide', class extends HTMLElement {
      connectedCallback() {
        this.history = ['1'];
        this.addEventListener('click', (e) => {
          const btn = e.target.closest('button');
          if (!btn) return;
          if (btn.dataset.next) this.show(btn.dataset.next, true);
          else if (btn.dataset.result) this.result(btn.dataset.result);
          else if (btn.hasAttribute('data-back')) this.back();
          else if (btn.hasAttribute('data-restart')) { this.history = []; this.show('1', true); }
        });
      }
      step() { this.dataset.step = String(Math.min(3, this.history.length)); }
      show(q, push) {
        if (push) this.history.push(q);
        this.querySelectorAll('.cc-quiz__q').forEach((f) => { f.hidden = f.dataset.q !== q; });
        this.querySelector('.cc-quiz__result').hidden = true;
        this.querySelector('[data-back]').hidden = this.history.length < 2;
        this.step();
        const legend = this.querySelector(`.cc-quiz__q[data-q="${q}"] legend`);
        if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus({ preventScroll: true }); }
      }
      back() {
        this.history.pop();
        const prev = this.history[this.history.length - 1] || '1';
        if (!this.history.length) this.history = ['1'];
        this.show(prev, false);
      }
      result(handle) {
        this.history.push('result');
        this.querySelectorAll('.cc-quiz__q').forEach((f) => { f.hidden = true; });
        const res = this.querySelector('.cc-quiz__result');
        res.hidden = false;
        res.querySelectorAll('[data-handle]').forEach((c) => { c.hidden = c.dataset.handle !== handle; });
        this.querySelector('[data-back]').hidden = false;
        this.dataset.step = '3';
        res.querySelector('.cc-eyebrow')?.setAttribute('tabindex', '-1');
        res.querySelector('.cc-eyebrow')?.focus({ preventScroll: false });
      }
    });
  }
})();

/* Bannière cookies : le choix est transmis à l'API de consentement Shopify. */
(() => {
  const box = document.getElementById('CcCookie');
  if (!box) return;
  const KEY = 'cc_consent_v1';
  const store = (val) => { try { if (val === undefined) return localStorage.getItem(KEY); localStorage.setItem(KEY, val); } catch (e) { return null; } return null; };
  const prefs = box.querySelector('#CcCookiePrefs');
  const more = box.querySelector('[data-cc-cookie="custom"]');
  const saveBtn = box.querySelector('[data-cc-cookie="save"]');
  const pref = (name) => box.querySelector(`[data-cc-pref="${name}"]`);

  const withApi = (cb) => {
    const sh = window.Shopify;
    if (sh && sh.customerPrivacy) return cb(sh.customerPrivacy);
    if (sh && typeof sh.loadFeatures === 'function') {
      sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => cb(!err && sh.customerPrivacy ? sh.customerPrivacy : null));
    } else cb(null);
  };

  const showPrefs = () => {
    prefs.hidden = false;
    saveBtn.hidden = false;
    more.setAttribute('aria-expanded', 'true');
  };
  const open = (withPrefs) => {
    box.hidden = false;
    requestAnimationFrame(() => box.classList.add('is-open'));
    if (withPrefs) {
      showPrefs();
      box.querySelector('#CcCookieTitle').focus({ preventScroll: true });
    }
  };
  const close = () => {
    box.classList.remove('is-open');
    setTimeout(() => { box.hidden = true; }, 260);
  };
  const save = (c) => {
    store(JSON.stringify({ ...c, date: new Date().toISOString() }));
    ['analytics', 'marketing', 'preferences'].forEach((k) => { pref(k).checked = c[k]; });
    withApi((cp) => {
      if (cp) cp.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.preferences, sale_of_data: c.marketing }, () => {});
    });
    close();
  };

  withApi((cp) => {
    let decided = false;
    const saved = store();
    if (saved) {
      try {
        const s = JSON.parse(saved);
        ['analytics', 'marketing', 'preferences'].forEach((k) => { pref(k).checked = !!s[k]; });
        decided = Date.now() - new Date(s.date).getTime() < 365 * 864e5;
      } catch (e) { decided = false; }
    }
    if (cp && typeof cp.currentVisitorConsent === 'function') {
      const v = cp.currentVisitorConsent() || {};
      if (v.analytics || v.marketing || v.preferences) {
        decided = true;
        ['analytics', 'marketing', 'preferences'].forEach((k) => { if (v[k]) pref(k).checked = v[k] === 'yes'; });
      }
    }
    if (!decided) open(false);
  });

  box.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cc-cookie]');
    if (!b) return;
    const a = b.dataset.ccCookie;
    if (a === 'accept') save({ analytics: true, marketing: true, preferences: true });
    else if (a === 'refuse') save({ analytics: false, marketing: false, preferences: false });
    else if (a === 'custom') showPrefs();
    else if (a === 'save') save({ analytics: pref('analytics').checked, marketing: pref('marketing').checked, preferences: pref('preferences').checked });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-cc-cookie-open]')) return;
    e.preventDefault();
    open(true);
  });
})();
